module.exports = __webpack_public_path__ + "static/img/file1.e11f3d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/file1.png
// module id = i3fd
// module chunks = 1